import {
  ValidationError,
  lazy,
  number,
  object,
  string,
  type InferType,
} from "yup"

/** Represents an address object */
export const AddressObjectSchema = object({
  street: string(),
  number: string(),
  zip: string(),
  city: string(),
  country: string(),
  gps: object({
    lat: number().required().positive(),
    lng: number().required().positive(),
  })
    .optional()
    .nullable()
    // Without this, yup substitutes `{}` for a missing `gps` and then fails on
    // the required `lat`/`lng`. An address without coordinates is valid.
    .default(undefined),
})

/** Represents an address, either JSON serialized, or as an object */
export const AddressSchema = lazy((value) => {
  switch (typeof value) {
    case "object":
      return AddressObjectSchema.required()
    case "string":
      return string().required()
    default:
      throw new ValidationError("Address does not satisfy AddressSchema")
  }
})

export type AddressDto = InferType<typeof AddressSchema>
export type AddressObjectDto = InferType<typeof AddressObjectSchema>
